import { render, staticRenderFns } from "./QuickEndSettingsTooltipContent.vue?vue&type=template&id=2c082092"
import script from "./QuickEndSettingsTooltipContent.vue?vue&type=script&lang=ts"
export * from "./QuickEndSettingsTooltipContent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports